const charA = 'A'.charCodeAt(0);

export default function indexToLetter(index) {
    return String.fromCharCode(charA + index);
}